import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'

import {MilestoneDate} from './MilestoneDate'
import {MilestoneIssueCount} from './MilestoneIssueCount'
import {MilestoneRowMetadata} from './MilestoneRowMetadata'
import {MilestoneRowTitle} from './MilestoneRowTitle'
import type {MilestoneNode} from './repository-milestone-index-page-query-types'
import styles from './RepositoryMilestone.module.css'

// RELAY-CLEANUP(RepositoryMilestonesInternal): widens nullable fields so the still-Relay parent
// data is assignable. Remove when RepositoryMilestonesInternal leaves Relay.
export type MilestoneRowFragment = RelayCompat<
  Pick<
    MilestoneNode,
    | 'closed'
    | 'closedIssueCount'
    | 'description'
    | 'dueOn'
    | 'id'
    | 'openIssueCount'
    | 'progressPercentage'
    | 'repository'
    | 'state'
    | 'title'
    | 'url'
  >
>

type MilestoneRowProps = {
  milestone: MilestoneRowFragment
  repositoryNameWithOwner: string
}

export function MilestoneRow({milestone: data, repositoryNameWithOwner}: MilestoneRowProps) {
  const title = <MilestoneRowTitle milestone={data} />
  const metadata = <MilestoneRowMetadata milestone={data} repositoryNameWithOwner={repositoryNameWithOwner} />

  return (
    <ListItem
      key={data.id}
      title={title}
      role="listitem"
      metadata={metadata}
      className={styles.milestoneRow}
      metadataContainerClassName={styles.listMetadataContainer}
    >
      <ListItemMainContent>
        <ListItemDescription className={styles.listItemContent}>
          {data.description && <p className={styles.listDescription}>{data.description}</p>}
          <div className={styles.listDateContainer}>
            <MilestoneDate milestone={data} />
            <MilestoneIssueCount milestone={data} />
          </div>
        </ListItemDescription>
      </ListItemMainContent>
    </ListItem>
  )
}
